export function formatPercent(numerator: number, denominator: number) {
  const percentage = denominator === 0 ? 0 : (numerator / denominator) * 100;
  let formatted;

  if (numerator !== 0 && percentage < 1) {
    formatted = "<1";
  } else if (numerator !== denominator && percentage > 99) {
    formatted = ">99";
  } else {
    formatted = String(Math.round(percentage));
  }
  return formatted + "%";
}
